<template>
    <div>
        <div class="basic-info">
            <el-row class="row">
                <el-col :span="4" class="label">提交人</el-col>
                <el-col :span="8" class="value">{{detailInfo.submitUser}}</el-col>
                <el-col :span="4" class="label">审批人</el-col>
                <el-col :span="8" class="value">{{detailInfo.approval}}</el-col>
            </el-row>
            <el-row class="row">
                <el-col :span="4" class="label">提交时间</el-col>
                <el-col :span="8" class="value">{{detailInfo.createTime}}</el-col>
                <el-col :span="4" class="label">审批时间</el-col>
                <el-col :span="8" class="value">{{detailInfo.approvalTime}}</el-col>
            </el-row>
            <el-row class="row">
                <el-col :span="4" class="label">审批状态</el-col>
                <el-col :span="8" class="value">{{detailInfo.auditStatus_}}</el-col>
                <el-col :span="4" class="label">流程编码</el-col>
                <el-col :span="8" class="value">{{detailInfo.flowId}}</el-col>
            </el-row>
        </div>
        <el-table class="progress-table" v-loading="loading" :row-class-name="tableRowClassName" border
            :data="tableData" style="width: 100%" max-height="200">
            <el-table-column show-overflow-tooltip prop="workerName" label="姓名" width="100">
            </el-table-column>
            <el-table-column show-overflow-tooltip prop="supplierName" label="供应商名称" width="180">
            </el-table-column>
            <el-table-column show-overflow-tooltip prop="_confirmStatus" label="工资确认" width="100">
            </el-table-column>
            <el-table-column show-overflow-tooltip prop="_noPaySalaryReason" label="薪资未发原因" width="260">
            </el-table-column>
            <el-table-column show-overflow-tooltip label="附件" width="180">
                <template slot-scope="scope">
                    <el-button v-if="!!scope.row.fileName" type="text" @click=handlePreview(scope.row) size="small">{{ scope.row.fileName }}</el-button>
                </template>
            </el-table-column>
            <el-table-column show-overflow-tooltip prop="contractCode" label="单据编码" width="180">
            </el-table-column>
            <el-table-column show-overflow-tooltip prop="companyName" label="分公司" width="180">
            </el-table-column>
            <el-table-column show-overflow-tooltip prop="businessName" label="经营中心" width="180">
            </el-table-column>
            <el-table-column show-overflow-tooltip prop="physicalWarehouseName" label="物流仓" width="180">
            </el-table-column>
            <el-table-column show-overflow-tooltip prop="salaryReasonRemark" label="原因说明">
            </el-table-column>
        </el-table>
        <el-pagination style="text-align: right;margin-top: 10px;" @size-change="handleSizeChange"
            @current-change="handleCurrentChange" :current-page="pageNo" :page-sizes="[10, 20, 30, 50]"
            :page-size="pageSize" layout="total, sizes, prev, pager, next, jumper" :total="total">
        </el-pagination>
        <Preview
            v-if="attachmentShow"
            :attachmentList="attachmentList"
            :attachmentShow.sync="attachmentShow"
            :rowData="rowData"
        ></Preview>
    </div>
</template>
<script>
import { dictWithUrl } from '@/components/lots/api'
import { noPaySalaryReasonListByFlowId, auditInfo } from '../../../api/warehouseResourceManagement/loaderSalaryConfirm.js'
import Preview from '../../../components/viewAttachment.vue';
export default {
    components: { Preview },
    props: ['fdId', 'confirmCode'],
    data() {
        return {
            dict: {},
            tableData: [],
            loading: false,
            pageSize: 10,
            pageNo: 1,
            total: 0,
            detailInfo: {},
            attachmentShow: false,
            rowData: {},
            attachmentList: [],
        }
    },
    mounted() {
        dictWithUrl('NO_PAY_SALARY_REASON,SALARY_CONFIRM_STATUS,SALARY_REASON_AUDIT_STATUS').then(res => {
            if (res && +res.code === 0) {
                this.dict = res.data
                this.getList()
                this.auditInfo()
            }
        })
    },
    methods: {
        auditInfo(){
            auditInfo({confirmCode: this.confirmCode}).then(res => {
                if (res && +res.code === 0) {
                    if(res.data.auditStatus){
                        res.data.auditStatus_ = this.dict['SALARY_REASON_AUDIT_STATUS'][res.data.auditStatus]
                    }
                    this.detailInfo = res.data
                }
            })
        },
        tableRowClassName({ row, rowIndex }) {
            if (row.confirmCode === this.confirmCode) return 'current-row';
            return '';
        },
        handleCurrentChange(v) {
            this.pageNo = v
            this.getList()
        },
        handleSizeChange(v) {
            this.pageSize = v
            this.pageNo = 1
            this.getList()
        },
        getList() {
            this.loading = true
            noPaySalaryReasonListByFlowId({ flowId: this.fdId, confirmCode: this.confirmCode, pageNo: this.pageNo, pageSize: this.pageSize }).then(res => {
                if (res && +res.code === 0) {
                    this.tableData = (res.data.list || []).map(v => {
                        return {
                            ...v,
                            _noPaySalaryReason: v.noPaySalaryReason ? v.noPaySalaryReason.split(',').map(s => this.dict['NO_PAY_SALARY_REASON'][s])+'' : '',
                            _confirmStatus: this.dict['SALARY_CONFIRM_STATUS'][v.confirmStatus],
                        }
                    })
                    this.total = res.data.totalCount
                }
            }).finally(() => {
                this.loading = false
            })
        },
        handlePreview(data) {
            this.rowData = {
                downUrl: data.fileUrl,
                fileName: data.fileName,
                fileId: data.fileId
            };
            this.attachmentShow = true;
        },
    },
}
</script>
<style lang="less">
.progress-table {
    .current-row>td {
        background: #f56c6c !important;
    }
}
.basic-info{
    border-top: 1px solid #ddd;
    border-left: 1px solid #ddd;
    margin-bottom: 20px;
    .row{
        display: flex;
    }
    .label{
        display: flex;
        align-items: center;
        justify-content: center;
        background: #f5f7fa;
        min-height: 30px;
        padding: 6px;
        border-right: 1px solid #ddd;
        border-bottom: 1px solid #ddd;
    }
    .value{
        word-break: break-all;
        display: flex;
        align-items: center;
        justify-content: flex-start;
        min-height: 30px;
        padding: 6px;
        border-right: 1px solid #ddd;
        border-bottom: 1px solid #ddd;
    }
}
</style>
